<template>
  <div v-test="{ 'right-menu': 'container' }" class="d-flex align-center" style="margin-left: auto">
    <span v-test="{ data: 'currentUserName' }">
      {{ currentUserName }}
    </span>
    <v-menu
        open-on-hover
        right
        offset-y
        close-on-content-click
        close-on-click
        nudge-width="200">
      <template v-slot:activator="{ on }">
        <v-btn
            v-test="{ 'right-menu': 'icon' }"
            icon
            v-on="on">
          <v-icon>
            person
          </v-icon>
        </v-btn>
      </template>
      <!-- loggen in user's menu -->
      <v-list dense>
        <v-list-item
            v-for="(item, ind) in displayItems"
            :key="ind"
            v-test="{ 'right-menu': item.id }"
            link
            v-bind="item.route
              ? { to: item.route }
              : {}"
            v-on="item.method
              ? { click: item.method }
              : {}">
          <v-list-item-icon>
            <v-icon v-text="item.icon" />
          </v-list-item-icon>
          <v-list-item-content class="text-left align-self-start">
            <v-list-item-title v-text="item.text" />
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
    <my-profile-dialog
        v-if="myProfileDialog.show"
        :dialog-prop="myProfileDialog"
        @close="closeDialog('myProfileDialog')" />
    <subscriptions />
    <locale-switcher
        v-if="localizationEnabled" />
  </div>
</template>

<script>
  import Subscriptions from './Subscriptions.vue'
  import LocaleSwitcher from './LocaleSwitcher.vue'
  import MyProfileDialog from '@/components/reused/common/MyProfileDialog.vue'
  export default {
    components: {
      LocaleSwitcher,
      Subscriptions,
      MyProfileDialog
    },
    data () {
      return {
        myProfileDialog: {
          show: false
        }
      }
    },
    computed: {
      displayItems () {
        return this.items.filter(item => item.show)
      },
      items () {
        return [
          {
            id: 'exit',
            icon: 'exit_to_app',
            text: this.$t('Выйти'),
            route: null,
            method: this.logOut,
            show: this.isLoggedIn
          },
          {
            id: 'login',
            icon: 'person',
            text: this.$t('Войти'),
            route: { path: `${this.urlRootPath}/login` },
            method: null,
            show: !this.isLoggedIn
          },
          {
            id: 'orgregistration',
            icon: 'assignment',
            text: this.$t('Регистрация организации'),
            route: { path: `${this.urlRootPath}/user/registration/start` },
            method: null,
            show: this.isLoggedIn && !this.isAdmin
          },
          {
            id: 'registration',
            icon: 'person_add',
            text: this.$t('Регистрация'),
            route: { path: `${this.urlRootPath}/registration` },
            method: null,
            show: !this.isLoggedIn
          },
          {
            id: 'profile',
            icon: 'account_box',
            text: this.$t('Мой профиль'),
            route: null,
            method: this.openMyProfileDialog,
            show: this.isLoggedIn
          }
        ]
      }
    },
    methods: {
      openMyProfileDialog: function () {
        this.myProfileDialog.show = true
      }
    }
  }
</script>
